import { environment as prodEnvironment } from './environment.prod';

export const environment = {
  ...prodEnvironment,

  api: {
    rootUrl: 'https://dev-api.resolve.com',
  },
  azureADB2C: {
    apiPermissionRootUrl:
      'https://resolvepracticedev.onmicrosoft.com/client-gateway',
    authorityDomain: 'resolvepracticedev.b2clogin.com',
    clientId: 'e74435e4-f354-4141-a8d6-86444bf63961',
    userFlow: {
      name: 'B2C_1_SignInOnly',
      authority:
        'https://resolvepracticedev.b2clogin.com/resolvepracticedev.onmicrosoft.com/B2C_1_SignInOnly',
    },
  },
  gtmAccountId: 'GTM-MHHM2S6W',
  production: false,
  web: {
    rootUrl: 'https://dev.resolve.com',
  },
};
